"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.diff = diff;
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
/**
 * Computes the differences between two objects and returns an object describing the changes.
 *
 * This function compares the properties of two objects (`oldObj` and `newObj`) and returns an object
 * where the keys are the names of the properties that differ, and the values are objects containing
 * the old value (`oldValue`) and the new value (`newValue`) where applicable.
 *
 * @param {Record<string, any>} oldObj - The original object to compare.
 * @param {Record<string, any>} newObj - The new object to compare against the original.
 * @returns {ObjectDiff} An object representing the differences between `oldObj` and `newObj`.
 *
 * @example
 * // Example usage:
 * const oldObj = { a: 1, b: 2, c: 3 };
 * const newObj = { a: 1, b: 4, d: 5 };
 *
 * const differences = diff(oldObj, newObj);
 * console.log(differences);
 * // Output:
 * // {
 * //     b: { oldValue: 2, newValue: 4 },
 * //     c: { oldValue: 3 },
 * //     d: { newValue: 5 }
 * // }
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function diff(oldObj, newObj) {
    const objectDiff = {};
    for (const key in oldObj) {
        if (Object.prototype.hasOwnProperty.call(oldObj, key)) {
            const oldValue = oldObj[key];
            const newValue = newObj[key];
            if (!(key in newObj)) {
                objectDiff[key] = { oldValue };
            }
            else if (!(0, lodash_isequal_1.default)(oldValue, newValue)) {
                objectDiff[key] = { oldValue, newValue };
            }
        }
    }
    for (const key in newObj) {
        if (Object.prototype.hasOwnProperty.call(newObj, key) && !(key in oldObj)) {
            const newValue = newObj[key];
            objectDiff[key] = { newValue };
        }
    }
    return objectDiff;
}
